import React from 'react';
import {connect} from 'react-redux';
import {Router, Route, Redirect, Switch} from 'react-router-dom';

import * as Sentry from '@sentry/react';

import ChatContainer from '../components/Chat';
import ExpiredContainer from '../components/Expired';
import ForgotContainer from '../components/Forgot';
import VerifyContainer from '../components/Verify';
import ReVerify from '../components/ReVerify';
import Logout from '../components/Logout';
import Unauthorized from '../components/Unauthorized';
import MenuContainer from '../components/Menu/MenuContainer';

let env = 'production';

initializeSentry();

// Create Custom Sentry Route component
const SentryRoute = Sentry.withSentryRouting(Route);

// use SentryRoute if Sentry was initialized, otherwise fallback to normal Routes
const MaybeWrappedWithSentryRoute = ({...props}) => Sentry.isInitialized() ?
    <SentryRoute {...props}/> :
    <Route {...props}/>;

const AuthRoute = ({loggedIn, ...rest}) =>
    loggedIn ?
        <MaybeWrappedWithSentryRoute {...rest}/> :
        <Redirect to={{pathname: "/unauthorized", state: {from: rest.location}}}/>;

const RootRouter = ({loggedIn, history}) =>
    <Router history={history}>
        <Switch>
            <MaybeWrappedWithSentryRoute path="/forgot/:conversationHash" component={ForgotContainer}/>
            <MaybeWrappedWithSentryRoute path="/verify/:conversationHash" component={VerifyContainer}/>
            <MaybeWrappedWithSentryRoute path="/reverify/:conversationHash" component={ReVerify}/>
            <MaybeWrappedWithSentryRoute path="/expired/:conversationHash" component={ExpiredContainer}/>
            <AuthRoute loggedIn={loggedIn} path="/chat/:conversationHash" component={ChatContainer}/>
            <AuthRoute loggedIn={loggedIn} path="/menu/:conversationHash" component={MenuContainer}/>
            <MaybeWrappedWithSentryRoute path="/logout" component={Logout}/>
            <Route path="/unauthorized" component={Unauthorized}/>
        </Switch>
    </Router>;

function initializeSentry() {
    if (window.location.hostname.match(/localhost/)) {
        env = 'dev'
        return; // comment out this line if you want to force Sentry usage in a local dev env
    } else if (window.location.hostname.match(/updoxtest|updoxqa|qa\.sharecaretelehealth|updoxperf/)) {
        env = 'testing';
    }

    console.log('Initializing Sentry for the ' + env + ' region');
    Sentry.init({
        dsn: 'https://7fbf6fbe3dcd99a71a60052bb0010ccf@o4506220010274816.ingest.us.sentry.io/4508801502871552',
        environment: env,
    });
}
/**
 * connect() the entire <Router /> tree with loggedIn session state
 */
export default connect(
    state => ({loggedIn: state.session.loggedIn})
)(RootRouter);
